import { render, staticRenderFns } from "./TouristsQuantityGroup.vue?vue&type=template&id=ac06db8a"
import script from "./TouristsQuantityGroup.vue?vue&type=script&lang=js"
export * from "./TouristsQuantityGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports